import { APIClient, serializeFormdata } from 'DVWebNodeUtils';


export default function fetch(url: string, isUsingMock: boolean = false, method?: string, body?: string) {
  const options: { [key: string]: any } = isUsingMock ? {} : { credentials: 'include' }
  if (method === 'POST') {
    options.method = method
    options.headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'x-requested-with': 'XMLHttpRequest'
    }
    if (body) {
      options.body = serializeFormdata(body)
    }
  }

  const api = new APIClient
  return api.call(url, options)
}
